import Vue from 'vue'
import Vuex from 'vuex'
import { supabase } from '@/supabase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Loading states
    configLoading: true,
    configError: null,

    // Auth state
    user: null,

    // Raw site configuration from Supabase
    siteConfig: null,

    // Config values (camelCase for component compatibility)
    formURL: '',
    contestantURL: '',
    s3ContentsUrl: '',
    registrationLink: '',
    vipTicketLink: '',
    generalTicketLink: '',
    donateLink: '',
    sponsorLink: '',
    bucket: '',
    sponsorsPrefix: '',
    region: '',
    doorFee: '',
    onlineFee: '',
    vipFee: '',
    entryFee: '',
    prizeAmount: '',
    eventDate: '',
    doorsTime: '',
    eventTime: '',
    arrivalTime: '',
    registrationStart: '',
    registrationEnd: '',
    entryFeePaid: '',
    musicDeadLine: '',
    charityBenefactor: '',
    theme: '',
    descriptionBlocks: [],
    eventImage: '',
    donateButtonText: 'Donate',
    getTicketsText: 'Get Tickets',
    showCountdown: true
  },

  getters: {
    isAuthenticated: state => !!state.user,
    isConfigLoaded: state => !state.configLoading && !state.configError
  },

  mutations: {
    setConfigLoading(state, loading) {
      state.configLoading = loading
    },

    setConfigError(state, error) {
      state.configError = error
    },

    setUser(state, user) {
      state.user = user
    },

    setSiteConfig(state, config) {
      state.siteConfig = config

      // Map snake_case from DB to camelCase for components
      state.formURL = config.form_url
      state.contestantURL = config.contestant_url
      state.s3ContentsUrl = config.s3_contents_url
      state.registrationLink = config.registration_link
      state.vipTicketLink = config.vip_ticket_link
      state.generalTicketLink = config.general_ticket_link
      state.donateLink = config.donate_link
      state.sponsorLink = config.sponsor_link
      state.bucket = config.bucket
      state.sponsorsPrefix = config.sponsors_prefix
      state.region = config.region
      state.doorFee = config.door_fee
      state.onlineFee = config.online_fee
      state.vipFee = config.vip_fee
      state.entryFee = config.entry_fee
      state.prizeAmount = config.prize_amount
      state.eventDate = config.event_date
      state.doorsTime = config.doors_time
      state.eventTime = config.event_time
      state.arrivalTime = config.arrival_time
      state.registrationStart = config.registration_start
      state.registrationEnd = config.registration_end
      state.entryFeePaid = config.entry_fee_paid
      state.musicDeadLine = config.music_deadline
      state.charityBenefactor = config.charity_benefactor
      state.theme = config.theme
      state.eventImage = config.event_image || ''
      state.donateButtonText = config.donate_button_text || 'Donate'
      state.getTicketsText = config.get_tickets_text || 'Get Tickets'
      state.showCountdown = config.show_countdown !== false
      // Parse description blocks from JSON
      if (config.description_blocks) {
        try {
          state.descriptionBlocks = typeof config.description_blocks === 'string'
            ? JSON.parse(config.description_blocks)
            : config.description_blocks
        } catch (e) {
          state.descriptionBlocks = []
        }
      } else {
        state.descriptionBlocks = []
      }
    }
  },

  actions: {
    async fetchConfig({ commit }) {
      commit('setConfigLoading', true)
      commit('setConfigError', null)

      try {
        const { data, error } = await supabase
          .from('site_config')
          .select('*')
          .single()

        if (error) throw error

        commit('setSiteConfig', data)
      } catch (err) {
        console.error('Failed to fetch config:', err)
        commit('setConfigError', err.message || 'Failed to load configuration')
      } finally {
        commit('setConfigLoading', false)
      }
    },

    async checkAuth({ commit }) {
      const { data: { session } } = await supabase.auth.getSession()
      if (session) {
        commit('setUser', session.user)
      }

      // Listen for auth changes
      supabase.auth.onAuthStateChange((event, session) => {
        commit('setUser', session?.user || null)
      })
    }
  },

  modules: {}
})
